<template>
    <div>
        <SurveyDialog v-if="survey.dialog" :survey="survey" @close="close" />
    </div>
</template>

<script>
import { checkSurvey } from "@/api/survey";
import SurveyDialog from "@/components/Survey/SurveyDialog";
export default {
    name: 'SurveyAllUser',
    components: {
        SurveyDialog
    },
    data() {
        return {
            survey: {
                dialog: false
            },
        }
    },
    computed: {
        user() {
            return this.$store.getters.getUser;
        },
        contractList() {
            return this.$store.getters.getContractList;
        },
    },
    methods: {
        close() {
            console.log("close")
            this.survey.dialog = false
        },
        useSurveyVillageId() {
            return this.contractList.find((item) => {
                return [4567].includes(item.village);
            });
        },
        checkSurvey() {
            const home = this.useSurveyVillageId()
            if (!home) {
                return;
            }
            console.log(home, "contract_app")
            const query = {
                location: "contract_app",
                skip_ids: this.$store.getters.getSurveySkipList,
            }
            checkSurvey(home.id, query).then(({ data }) => {
                console.log(data)
                this.survey = data
                this.survey.dialog = true
            })
        },
        // checkSurvey() {
        // 전체 설문 조회는 아직 미사용.
        //     const query = {
        //         location: "all",
        //         skip_ids: this.$store.getters.getSurveySkipList,
        //     }
        //     checkSurvey(0, query).then(({ data }) => {
        //         console.log(data)
        //         this.survey = data
        //         this.survey.dialog = true
        //     })
        // },
    },
    created() {
        const pathName = this.$route.name

        // 설문 페이지에서 설문 안내가 뜨지 않도록 설정.
        if (!['surveyDetail'].includes(pathName)) {
            if (this.user && this.user.id) {
                console.log(this.user)
                this.checkSurvey();
            }
        }
    }
}

</script>